import React, { useState } from 'react';

export default function SubscriptionWarningBanner({ message, daysLeft }) {
  const [dismissed, setDismissed] = useState(false);
  if (!message || dismissed) return null;

  const urgent  = daysLeft <= 3;
  const warning = daysLeft <= 7;

  return (
    <div style={{
      padding: '10px 16px',
      background: urgent ? '#FFF5F5' : warning ? '#FFFBEB' : '#FFFBEB',
      borderBottom: `1px solid ${urgent ? '#FEB2B2' : '#FAF089'}`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '12px', fontSize: '13px',
      color: urgent ? 'var(--color-danger)' : '#744210',
      position: 'sticky', top: 0, zIndex: 60,
    }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>{urgent ? '🚨' : '⚠️'}</span>
        <span>{message}</span>
      </span>
      <button
        onClick={() => setDismissed(true)}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontSize: '18px', color: 'inherit', opacity: 0.6, flexShrink: 0,
        }}
      >×</button>
    </div>
  );
}
